import { graphql } from 'react-relay';

export default graphql`
    query mobileNavWrapperRootQuery (
        $hasUserId: Boolean!
        $showMarketingMessages: Boolean!
        # $fetchMarketingMessagesTransactions should be a local argument, but relay-runtime throws this error,
        # "Variable "$userIds" is never used in operation "mobileNavWrapperRootQuery,"
        # when "$userIds" is used in a conditional fragment behind a local variable.
        # https://github.com/facebook/relay/blob/9afd76498942ef8c7c8de64c6bfc5b1da2a1dd65/packages/relay-compiler/graphql-compiler/core/GraphQLValidator.js#L73
        $fetchMarketingMessagesTransactions: Boolean=false
        $userId: String!
        $userIds: [String!]
    ) {
        viewer {
            ...MobileNavWrapper_viewer
        }
    }
`;

export const initialVariables = {
    hasUserId: false,
    fetchMarketingMessagesTransactions: false,
    showMarketingMessages: false,
    userId: '',
    userIds: []
};




// WEBPACK FOOTER //
// ./src/queries/mobileNavWrapperRootQuery.js